import { LogLevel } from '@azure/msal-browser';
import { MAIN } from '../../configs/main.config';
import { logger } from '../logger.service';
import { BusEvent, EBusEvent } from '../bus-event/bus-event.service';

const origin = window.location.origin;

export const msalConfig = {
  auth: {
    clientId: MAIN.clientId,
    authority: `${MAIN.clientInstanceUrl}/${MAIN.tenantId}`,
    redirectUri: `${origin}/d365-app-container/index.html`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    allowRedirectInIframe: true,
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean,
      ) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            if (message.includes('error opening popup empty_window_error')) {
              BusEvent.sendEvent({ event: EBusEvent.DYN_NEEDED_POPUP });
              return;
            }

            BusEvent.sendEvent({ event: EBusEvent.DYN_VERIFIED_FAILED });
            return;
          case LogLevel.Warning:
            logger.warn(message);

            return;
          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = () => {
  return { scopes: [MAIN.apiScope] };
};
